import React from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
  getExpandedRowModel,
  getGroupedRowModel,
  getPaginationRowModel,
} from '@tanstack/react-table';
import styles from '../../../custom/style.module.css';

export default function TableWrapper({ columns, data, isClientPagination, pageIndex, pageSize, onRowClick }) {
  const [sorting, setSorting] = React.useState([]);
  const [grouping, setGrouping] = React.useState([]);

  const tableState = {
    sorting,
    grouping,
  };

  if (isClientPagination) {
    tableState.pagination = {
      pageIndex,
      pageSize,
    };
  }

  const table = useReactTable({
    data,
    columns,
    state: tableState,
    onGroupingChange: setGrouping,
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),

    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    ...(isClientPagination && { getPaginationRowModel: getPaginationRowModel() }),
  });

  return (
    <div style={{
      borderRadius: 8,
      minWidth: 'max-content',
      height: 'inherit',
      width: '100%',
      // paddingRight: '12px'
    }}>
      {/* <table style={{
        width: '100%',
        borderCollapse: 'collapse' 
      }}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} style={{ backgroundColor: '#f5f5f5' }}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                  style={{
                    cursor: 'pointer',
                    textAlign: 'left',
                    padding: '8px',
                    borderBottom: '2px solid #ddd',
                    userSelect: 'none',
                  }}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                  {header.column.getIsSorted() === 'asc' && ' 🔼'}
                  {header.column.getIsSorted() === 'desc' && ' 🔽'}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  style={{
                    borderBottom: '1px solid #eee',
                    padding: '8px',
                    textAlign: 'left',
                  }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table> */}
      <table className={styles.TStable}>
        <thead className={styles.TStableHead}>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id} className={styles.TStableHeadRow}>
              {headerGroup.headers.map(header => {
                const align = header.column.columnDef?.meta?.align || 'left';
                return (
                  <th key={header.id} colSpan={header.colSpan}
                    onClick={header.column.getToggleSortingHandler()}
                    style={{
                      cursor: 'pointer',
                      textAlign: align,
                      padding: '8px',
                      paddingInline: '16px',
                      borderBottom: '2px solid #ddd',
                      userSelect: 'none',
                    }}
                    className={styles.TStableHeadCell}
                  >
                    {header.isPlaceholder ? null : (
                      <div>
                        {/* {header.column.getCanGroup() ? (
                          // If the header can be grouped, let's add a toggle
                          <button
                            {...{
                              onClick: header.column.getToggleGroupingHandler(),
                              style: { cursor: 'pointer', },
                            }}
                          >
                            {header.column.getIsGrouped()
                              ? `🛑(${header.column.getGroupedIndex()}) `
                              : '👊 '}
                          </button>
                        ) : null}{' '} */}
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {header.column.getIsSorted() === 'asc' && ' 🔼'}
                        {header.column.getIsSorted() === 'desc' && ' 🔽'}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody className={styles.TStableBody}>
          {table.getRowModel().rows.map(row => {
            return (
              <tr
                key={row.id}
                className={styles.TStableBodyRow}
                onClick={(e) => {
                  if (onRowClick) {
                    onRowClick(row.original, e);
                  }
                }}
                style={onRowClick ? { cursor: 'pointer' } : undefined}
              >
                {row.getVisibleCells().map(cell => {
                  const align = cell.column.columnDef?.meta?.align || 'left';
                  return (
                    // <td key={cell.id} {...{
                    //   key: cell.id,
                    //   style: {
                    //     background: cell.getIsGrouped()
                    //       ? '#0aff0082'
                    //       : cell.getIsAggregated()
                    //         ? '#ffa50078'
                    //         : cell.getIsPlaceholder()
                    //           ? '#ff000042'
                    //           : 'white',
                    //   },
                    // }}
                    // >
                    <td key={cell.id} {...{
                      style: {
                        textAlign: align,
                        background: cell.getIsGrouped()
                          ? '#0aff0082'
                          : cell.getIsAggregated()
                            ? '#ffa50078'
                            : cell.getIsPlaceholder()
                              ? '#ff000042'
                              : 'white',
                      },
                    }}
                    className={styles.TStableBodyCell}
                    >
                      {cell.getIsGrouped() ? (
                        // If it's a grouped cell, add an expander and row count
                        <>
                          {/* <button
                            {...{
                              onClick: row.getToggleExpandedHandler(),
                              style: {
                                cursor: row.getCanExpand()
                                  ? 'pointer'
                                  : 'normal',
                              },
                            }}
                          >
                            {row.getIsExpanded() ? '👇' : '👉'}{' '} */}
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}{' '}
                            ({row.subRows.length})
                          {/* </button> */}
                        </>
                      ) : cell.getIsAggregated() ? (
                        // If the cell is aggregated, use the Aggregated
                        // renderer for cell
                        flexRender(
                          cell.column.columnDef.aggregatedCell ??
                            cell.column.columnDef.cell,
                          cell.getContext()
                        )
                      ) : cell.getIsPlaceholder() ? null : ( // For cells with repeated values, render null
                        // Otherwise, just render the regular cell
                        flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
